import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import SysAdminUserTableContainer from '../containers/sysadmin-user-table.container';
import SysAdminUserDetailsContainer from '../containers/sysadmin-user-details.container';
import SysAdminUserCreateContainer from '../containers/sysadmin-user-create.container';
import SysAdminUserUpdateContainer from '../containers/sysadmin-user-update.container';
import {
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGINATION_PAGE,
} from '../../../../../const/default-paginated-table-data.const';

// Helper function to add default query parameters to the user list page
const SysAdminUserListWithParams = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // Set default params if they don't exist
  if (!params.has('page')) {
    params.set('page', DEFAULT_PAGINATION_PAGE.toString());
  }
  if (!params.has('limit')) {
    params.set('limit', DEFAULT_PAGINATION_LIMIT.toString());
  }

  // If query params need to be added
  if (location.search !== `?${params.toString()}`) {
    return <Navigate to={`?${params.toString()}`} replace />;
  }

  return <SysAdminUserTableContainer />;
};

export const sysAdminUserRoutes = [
  {
    path: 'admin/user',
    element: <SysAdminUserListWithParams />,
  },
  {
    path: 'admin/user/create',
    element: <SysAdminUserCreateContainer />,
  },
  {
    path: 'admin/user/:id',
    element: <SysAdminUserDetailsContainer />,
  },
  {
    path: 'admin/user/:id/update',
    element: <SysAdminUserUpdateContainer />,
  },
];

export default sysAdminUserRoutes;
